import React, { useEffect, useState } from 'react';
export function ScrollProgress() {
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY / scrollHeight * 100;
      setScrollProgress(scrolled);
    };
    window.addEventListener('scroll', updateScrollProgress);
    return () => window.removeEventListener('scroll', updateScrollProgress);
  }, []);
  return <div className="fixed top-0 left-0 right-0 h-1 bg-slate-200 z-50" data-id="element-162">
      <div className="h-full bg-gradient-to-r from-blue-600 to-cyan-500 transition-all duration-150 ease-out" style={{
      width: `${scrollProgress}%`
    }} data-id="element-163" />
    </div>;
}